import PropTypes from "prop-types";

export const highlightSubstringPropTypes = {
  /** The substring that needs to be highlighted within the value. */
  substring: PropTypes.string,

  /** The value to be displayed potentially with the substring to be highlighted. */
  value: PropTypes.string,
};
